import { TrendingUp, Zap, Megaphone, ShieldCheck, ArrowRight } from "lucide-react";
import { Eyebrow, MaskHeading, Reveal } from "./Motion";
import { ADVANTAGES } from "./data";
import { scrollToId } from "../../lib/scroll";

const ICONS = { TrendingUp, Zap, Megaphone, ShieldCheck };

const AdvantageCard = ({ a, i }) => {
  const Icon = ICONS[a.icon];
  return (
    <Reveal delay={i * 0.1} className="h-full">
      <article data-testid={a.testId} className="group relative flex h-full flex-col rounded-[28px] border border-ns-gold/20 bg-ns-deep/60 p-7 transition-[background-color,transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-ns-gold/60 hover:bg-ns-deep sm:p-8">
        <div className="flex items-center justify-between">
          <span className="grid h-14 w-14 place-items-center rounded-full border border-ns-gold/40 text-ns-gold transition-colors duration-500 group-hover:bg-ns-gold group-hover:text-ns-emerald">
            <Icon className="h-6 w-6" />
          </span>
          <span className="font-serif text-4xl italic text-ns-gold/70">0{i + 1}</span>
        </div>
        <h3 className="mt-10 font-serif text-[1.9rem] font-semibold leading-tight text-ns-ivory">{a.title}</h3>
        <p className="mt-3 text-[15px] leading-relaxed text-ns-ivory/80">{a.text}</p>
      </article>
    </Reveal>
  );
};

export const Partners = () => (
  <section id="b2b" data-testid="b2b-section" className="relative overflow-hidden bg-ns-emerald py-24 text-ns-ivory md:py-36 grain">
    <span aria-hidden className="pointer-events-none absolute -bottom-24 -left-6 select-none font-serif text-[16rem] font-bold leading-none text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.18)] sm:text-[24rem]">NS</span>
    <div className="relative mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Eyebrow light testId="b2b-eyebrow">03 / For Partners</Eyebrow>
          <MaskHeading
            testId="b2b-heading"
            className="mt-6 font-serif text-[2.6rem] font-semibold leading-[1.02] sm:text-6xl lg:text-7xl"
            lines={["Partner with a brand", <em key="t" className="italic text-ns-gold">that moves.</em>]}
          />
          <Reveal>
            <p data-testid="b2b-supporting-copy" className="mt-8 max-w-md text-base leading-relaxed text-ns-ivory/80">
              From school canteens to supermarkets, our affordable, healthy impulse range is designed for visibility, velocity, and repeat purchase.
            </p>
            <button onClick={() => scrollToId("distributor")} data-testid="b2b-become-partner-btn" className="btn-gold group mt-10">
              Become a Partner
              <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>
      </div>
      <div className="grid gap-5 sm:grid-cols-2 lg:col-span-7">
        {ADVANTAGES.map((a, i) => <AdvantageCard key={a.testId} a={a} i={i} />)}
      </div>
    </div>
  </section>
);
